import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from 'src/common/api/emerald-request';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';
import { store } from 'src/common/redux/configure-store';
import { CashDrawerActions } from 'src/common/redux/reducers/cash-drawer-reducer';
import XLRLogger from '../common/helpers/logger';
import { TouchPointNotificationResponse } from './interface/touchpoint-notifications.interface';

export const getTouchPointNotifications = async (): Promise<void> => {
  const axiosConfig: AxiosRequestConfig = {
    url: '/notification-management/touchpoint-notifications',
    method: 'GET',
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
  };

  await emeraldRequest<TouchPointNotificationResponse>(emeraldRequestParams)
    .then(handleTouchPointNotifications)
    .catch((err): void => {
      XLRLogger.error(err);
    });
};

export const handleTouchPointNotifications = (
  tpNotifications: TouchPointNotificationResponse,
): void => {
  const cashDrawerLimitExceeded = tpNotifications?.notifications?.find(
    notification => notification.type === 'ExceedDrawerLimitNotification' && notification.value,
  );
  store.dispatch(CashDrawerActions.setDrawerLimitExceeded(!!cashDrawerLimitExceeded));
};
